import React, { useEffect } from 'react';
import './AboutUs.css';
import { FaGraduationCap, FaUsers, FaChalkboardTeacher, FaLightbulb, FaHandHoldingHeart } from 'react-icons/fa';

const AboutUs = () => {
    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in-visible');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.fade-in').forEach((element) => {
            observer.observe(element);
        });

        return () => {
            document.querySelectorAll('.fade-in').forEach((element) => {
                observer.unobserve(element);
            });
        };
    }, []);

    return (
        <div className="about-us-container">
            <div className="about-us-title">
                <h2>
                    <div className="top-text">About</div>
                    <div className="bottom-text">Our Legacy</div>
                </h2>
                <p className="subtitle">37 Years of Educational Excellence</p>
            </div>

            <div className="stats-container fade-in">
                <div className="stat-item">
                    <div className="stat-icon"><FaGraduationCap /></div>
                    <h3>1000+</h3>
                    <p>Doctors & Engineers Worldwide</p>
                </div>
                <div className="stat-item">
                    <div className="stat-icon"><FaUsers /></div>
                    <h3>35+</h3>
                    <p>Years of Excellence</p>
                </div>
                <div className="stat-item">
                    <div className="stat-icon"><FaChalkboardTeacher /></div>
                    <h3>650+</h3>
                    <p>Defence Officers</p>
                </div>
            </div>

            <div className="timeline">
                <div className="timeline-item left">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content fade-in fade-in-left">
                        <div className="timeline-icon">
                            <FaLightbulb />
                        </div>
                        <div className="timeline-year">1988</div>
                        <h3>THE BEGINNING</h3>
                        <p>Young Anees, known for his mathematical wizardry, established Anees Classes to help students prepare for NDA entrance exams.</p>
                    </div>
                </div>

                <div className="timeline-item right">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content fade-in fade-in-right">
                        <div className="timeline-icon">
                            <FaHandHoldingHeart />
                        </div>
                        <div className="timeline-year">2000s</div>
                        <h3>EXPANSION OF SERVICES</h3>
                        <p>Extended services to include coaching for Sainik Schools, Navodaya schools, Military schools (RIMC, RMS), and comprehensive education from class 1st to 12th.</p>
                    </div>
                </div>

                <div className="timeline-item left">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content fade-in fade-in-left">
                        <div className="timeline-icon">
                            <FaChalkboardTeacher />
                        </div>
                        <div className="timeline-year">2010s</div>
                        <h3>INNOVATION IN EDUCATION</h3>
                        <p>Introduced the MEAP program (Math-English-Aptitude-Psychology) focusing on holistic development of teachers, parents, and students.</p>
                    </div>
                </div>

                <div className="timeline-item right">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content fade-in fade-in-right">
                        <div className="timeline-icon">
                            <FaUsers />
                        </div>
                        <div className="timeline-year">2023</div>
                        <h3>CURRENT EXCELLENCE</h3>
                        <p>India's largest NDA entrance coaching center with over 500 alumni serving as officers in Indian Defence Forces.</p>
                    </div>
                </div>
            </div>

            <div className="founder-section">
                <div className="founder-content">
                    <div className="founder-image">
                        <img src="/images/founder.jpg" alt="Mr. Anees Kutty - Founder of Anees Classes" />
                    </div>
                    <div className="founder-text">
                        <h3>Meet Our Founder</h3>
                        <h2>Mr. Anees Kutty</h2>
                        <p className="founder-description">
                            Starting in 1988, Mr. Anees Kutty transformed his passion for mathematics and education into 
                            one of India's most successful defense training institutes. As the founder of both Anees Classes 
                            and the Evergreen Education Foundation, he has dedicated his life to education and helping 
                            underprivileged children access quality education.
                        </p>
                        <div className="founder-quote">
                            <blockquote>
                                "In an era of cut-throat competition, we believe in preparing students with a healthy and 
                                sharp personality especially for the Defence Forces. Our students are our best testimonials, 
                                their happiness is our motto, and their success our goal!"
                            </blockquote>
                        </div>
                        <div className="nda-levels">
                            <h4>NDA Coaching Levels</h4>
                            <ul>
                                <li>A1 Level: After 10th appearing 11th</li>
                                <li>A2 Level: After 11th appearing 12th</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;